import { AnyAction } from "redux";
import { Dispatch } from "react";
import { Result, } from "../../../../interfaces";
import { FindById } from "../../../actorTyes";

export const FETCH_DATA_ACTOR_TYPES_BY_ID_REQUEST = 'FETCH_DATA_ACTOR_TYPES_BY_ID_REQUEST';
export const FETCH_DATA_ACTOR_TYPES_BY_ID_SUCCESS = 'FETCH_DATA_ACTOR_TYPES_BY_ID_SUCCESS';
export const FETCH_DATA_ACTOR_TYPES_BY_ID_FAILURE = 'FETCH_DATA_ACTOR_TYPES_BY_ID_FAILURE';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchDataActorTypeByIdsRequest = () => {
    return {
        type: FETCH_DATA_ACTOR_TYPES_BY_ID_REQUEST,
    };
};

const fetchDataActorTypesByIdSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_DATA_ACTOR_TYPES_BY_ID_SUCCESS,
        payload: data
    };
};

const fetchDataActorTypesByIdFailure = (error: any) => {
    return {
        type: FETCH_DATA_ACTOR_TYPES_BY_ID_FAILURE,
        payload: error,
    };
};

export const findActorById = (id:string) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchDataActorTypeByIdsRequest());
        try {
            const response = await FindById(id);
            dispatch(fetchDataActorTypesByIdSuccess(response.data));

        } catch (error: any) {
            dispatch(fetchDataActorTypesByIdFailure(error.message));
        }
    };
};
